export default __webpack_public_path__ + "static/media/S-009.dd3aeecf.png";